import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';

@Component({
    components: AllComponents(),
})
export default class Mypage extends Mixins(CommonView) {
    kurukuru: boolean = false;
    pnkzList: {name: string, path: string | null}[] = [{name: "TOP", path: "/"},{name: "マイページ", path: null}];

    public async created() {
        this.kurukuru = true;
        if (await this.isLoginRedirect(true)) return;

        this.kurukuru = false;
    }
}
